export default __webpack_public_path__ + "static/media/icon-success.f83b7133.svg";